// Compiled structure index (F08 output) with typed accessors.
import data from '../generated/structures.json';
import redirectsData from '../generated/redirects.json';
import type { LayerId } from '../viewer/layers';
import type { Side } from '../viewer/Viewer';

export interface StructureEntry {
  id: string;
  title: string;
  name: string;
  oneLiner: string;
  kind: 'full' | 'stub' | 'none';
  system: string;
  layer: LayerId;
  region: string;
  sides: Side[];
  selectable: boolean;
  sensitive: boolean;
  aliases: { everyday: string[]; synonyms: string[]; misspellings: string[] };
  seeAlso: string[];
  bbox: { min: number[]; max: number[] };
  /** Present only for parts that exist in one body (F22): 'f' female-only, 'm' male-only. */
  body: 'm' | 'f' | null;
  bestView: { preset?: 'front' | 'back' | 'left' | 'right' | 'top' | 'medial' | 'lateral'; zoom?: number } | null;
}

export const STRUCTURES = data as StructureEntry[];
export const BY_ID = new Map(STRUCTURES.map((s) => [s.id, s]));
export const REDIRECTS = redirectsData as Record<string, string>;

export const REGIONS: Array<{ id: string; label: string }> = [
  { id: 'head', label: 'Head' },
  { id: 'neck', label: 'Neck' },
  { id: 'thorax', label: 'Chest' },
  { id: 'back', label: 'Back' },
  { id: 'abdomen', label: 'Abdomen' },
  { id: 'pelvis', label: 'Pelvis & hips' },
  { id: 'upper-limb', label: 'Arm & hand' },
  { id: 'lower-limb', label: 'Leg & foot' },
];
export const REGION_LABEL = Object.fromEntries(REGIONS.map((r) => [r.id, r.label]));

export function resolveId(id: string): string | null {
  if (BY_ID.has(id)) return id;
  const r = REDIRECTS[id];
  return r && BY_ID.has(r) ? r : null;
}

export const sideLabel = (side?: Side) => (side === 'l' ? 'left' : side === 'r' ? 'right' : '');
